import { colors, fontSize, size } from '@styles/theme'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, LinearProgress, Popover } from '@mui/material'
import styled from '@emotion/styled'

const NoButton = styled(Button)`
  width: 100%;
  border-radius: 100px;
  border: 1px solid grey;
`
  
const YesButton = styled(Button)`
  width: 100%;
  margin: 0;
  border-radius: 100px;
  color: white;
  background-color: ${colors.statusColors.right_now('primary')};
`

const Title = styled(DialogTitle)`
  font-size: ${fontSize('xl')};
  padding: ${size(2)} ${size(4)};
  border-bottom: 0.5px solid rgba(255,255,255, 0.25);
`

const linearProgressStyles = (isLoadingDelayed) => ({
  visibility: isLoadingDelayed ? 'visible' : 'hidden',
  position: 'absolute',
  width: '100%',
  top: 0,
  left: 0,
})

const slotProps = {
  paper: {
    style: {
      backgroundColor: '#333333',
      textAlign: 'center',
      borderRadius: '12px',
      border: '0.5px solid rgba(255,255,255, 0.25)',
    }
  }
}

const YesOrNo = ({ isOpen, setClosed, handleSelect, title, body, isLoading, isLoadingDelayed }) => {

  const handleOnClose = (e) => {
    e.stopPropagation()
    setClosed()
  }

  const handleYes = (e) => {
    e.stopPropagation()
    handleSelect(true)
  }

  const handleNo = (e) => {
    e.stopPropagation()
    handleSelect(false)
  }

  return (
    <Dialog
      open={isOpen}
      onClose={handleOnClose}
      slotProps={slotProps}
      // aria-labelledby="alert-dialog-slide-title"
      // aria-describedby="alert-dialog-slide-description"
      >
      <LinearProgress style={linearProgressStyles(isLoadingDelayed)} />
      <Title
        id="alert-dialog-slide-title">
        {title}
      </Title>
      {body &&
          <DialogContent style={{ paddingTop: size(3) }}>
            <DialogContentText
              style={{ color: 'white', fontSize: fontSize('sm') }}
              id="alert-dialog-slide-description">
              {body}
            </DialogContentText>
          </DialogContent>
      }
      <DialogActions>
        <NoButton
          // NOTE: Setting the background-color here disables the purple on focus, etc
          style={{ backgroundColor: 'transparent' }}
          disabled={isLoading}
          onClick={handleNo}
          variant='contained'>
          No
        </NoButton>
        <YesButton
          disabled={isLoading}
          onClick={handleYes}
          variant='contained'>
          Yes
        </YesButton>
      </DialogActions>
    </Dialog>
  )
}

export default YesOrNo